import styled, { css } from 'styled-components'
import Flex from 'Components/Flex'
import EllipsisText from 'Components/EllipsisText'
import {
  BREAK_POINT_SM, BREAK_POINT_MD, BREAK_POINT_LG,
  SEARCH_PAGE_BOTTOM_FLOATING_BAR_HEIGHT,
} from '@CSSVars/variables'
import {
  OUTLINE_COLOR, GREY_BACKGROUND,
  LINK_COLOR, TEXT_GREY,
} from '@CSSVars/colors'


export const _TitleCountContainer = styled(Flex)`
  position: relative;
  height: 34px;
  background: white;
  padding: 0 16px;

  a > div {
    font-size: 12px;
    line-height: 22px;
    color: ${LINK_COLOR};
    margin-right: 4px;
  }

  > div {
    margin-left: 6px;
    font-size: 12px;
    line-height: 22px;
    color: ${TEXT_GREY};
  }
`

export const _CloseBtn = styled.div`
  height: 22px;
  width: 22px;
  border-radius: 50%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 8px;
  left: 8px;

  background-color: rgba(16,16,16,.6);
  svg {
    fill: white;
  }

  ${({ multiListings }) => (multiListings ?
    `
      top: 22px;
      left: 28px;
      background-color: transparent;
      svg {
        fill: transparent;
        path {
          stroke: ${LINK_COLOR};
        }
      }
    ` : ''
  )}
`
export const _ListingCards = styled(Flex)`
  background: white;
  a {
    width: 100%;
  }

`
export const _Separator = styled.span`
  color: ${OUTLINE_COLOR};
  padding: 0 4px;
`

export const _BuildingName = styled(EllipsisText)`

  justify-content: center;
  span {
    max-width: 260px;
  }
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    span {
      max-width: 246px;
    }
  }
  @media screen and (max-width: 320px) {
    span {
      max-width: 180px;
    }
  }
`

const mapListingPopupCss = css`
  position: initial;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: white;
`

const mapListingCss = css`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1002;
  background: white;


  @media screen and (max-width: 320px) {
    align-items: center;
  }
`

const multiListingCss = css`
  padding-bottom: 16px;
  position: absolute;
  transform: translate3d(0,0,0);
  top: 64px;
  height: calc(100vh - 120px);
  background: white;
  z-index: 1007;
  -webkit-overflow-scrolling: touch;
  .mapboxgl-popup-content {
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25); !important;
  }
  ${_TitleCountContainer} {
    width: fit-content;
    height: 62px;
    padding: 16px 0;
    margin: auto;
    position: relative;
    display: block;
    text-align: center;

    a > div {
      max-width: 100%;
      font-size: 16px;
      font-weight: 600;
      line-height: 30px;
      margin-right: 0;
    }

    > div {
      margin-left: 0;
      font-size: 12px;
      line-height: 15px;
    }
  }
  ${_ListingCards} {
    height: calc(100vh - 108px);
    overflow-x: hidden;
    overflow-y: scroll;
    padding: 0;

    ${({ isBc }) => (isBc && `
      height: auto;
    `)}
  }
  ${({ multiListingMapPopup }) => (multiListingMapPopup && `
    position: initial;
    max-height: 300px;
    overflow: hidden;
    padding-bottom: calc(62px + 16px);
    ${_ListingCards} {
      height: 100%;
    }
  `)};
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    height: 100%;
    ${_ListingCards} {
      padding: 0 0 114px 0;
    }
  }
`

const mapListingPopupSingle = css`
  bottom: calc(${SEARCH_PAGE_BOTTOM_FLOATING_BAR_HEIGHT} + 16px);
  left: 16px;
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  border-radius: 10px;
  overflow: visible;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
  ${_ListingCards} {
    justify-content: center;
    border-radius: inherit;
  }
  ${_TitleCountContainer} {
    background-color: ${GREY_BACKGROUND};
    height: 34px;
    display: flex;
    justify-content: center;
    border-radius: inherit;
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: calc(100% - 32px);
  }
`

export const _MapListingPopup = styled.div`
  border-radius: 10px;

  ${({ popupStyle }) => (popupStyle ? mapListingPopupCss : mapListingCss)}
  ${({ multiListings }) => (multiListings ? multiListingCss : mapListingPopupSingle)}
  ${({ multiListings, isMobileApp }) => (multiListings && isMobileApp && 'top: 0;')}
`

export const _ForSale = styled(EllipsisText)`
  height: 22px;
`
